module.exports = __webpack_public_path__ + "img/box.2d093c0.e3ec87e3.png";